import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./App.css";
import "../index.scss";
import "./Sidemenu.scss";
import { getGroup, getUnit } from "../actions";

const mapStateToProps = (state) => ({
  uType: state.auth.uType
});

const mapDispatchToProps = dispatch => ({
  getGroup: payload => dispatch(getGroup(payload)),  
  getUnit: payload => dispatch(getUnit(payload)),  
});


const AdmMenu = ({ getGroup, getUnit, uType }) => {
  const gMenuClear = () => {
    getGroup('');
    getUnit('');
  };

  return uType == 'admin' ? (
    <div
      className="nav-side-menu"
      style={{ textAlign: "left", marginLeft: "0.2%" }}
    >
      <i
        className="fa fa-bars fa-2x toggle-btn"
        data-toggle="collapse"
        data-target="#menu-content"
      ></i>
      <header className="App-header" style={{ flexDirection: "raw" }}>
        <a href="/admin-dashboard" style={{ marginLeft: "7px", marginTop: '18px' }}>
          <img src="/images/logo.png" alt="citajte o" />
        </a>
      </header>

      <div className="menu-list">
        <ul id="menu-content" className="menu-content collapse out">
          <a href="/admin-dashboard/dl-group-li" className="a-m">
            ODREDNICE
          </a>
          <a href="/admin-dashboard/dl-unit-li" className="a-m">
            JEDINICE
          </a>
          <a href="/admin-dashboard/photo-ser-li" className="a-m">
            FOTO SERIJE
          </a>
          <a href="/admin-dashboard/user-li" className="a-m">
            KORISNICI
          </a>
          <Link to="/hemeroteka" className="a-m" style={{ marginTop: '2em' }} target="_blank" onClick={ gMenuClear }>
            HEMEROTEKA
          </Link>
          <Link to="/l-out" className="a-m" style={{ marginTop: '2em' }}>
            izloguj se
          </Link>
        </ul>
      </div>
    </div>
  ) : null;
};

export default connect(mapStateToProps, mapDispatchToProps)(AdmMenu);
